export const foundationColors = {
  white: '#FFFFFF',
  textPrimary: '#232323',
  textSecondary: '#666666',
  textMuted: '#64748B',
  disabled: '#64748B',
  brand: '#2A2277',
  primary: '#5954A8',
  secondaryAccent: '#A82682',
  success: '#02542D',
  successLight: '#2E7D4F',
  successBpmn: '#D4FCD4',
  error: '#900B09',
  errorDark: '#640706',
  warning: '#B86A00',
  info: '#0369A1',
  infoDark: '#01579B',
  infoLight: '#03A9F4',
  pageDefault: '#F5F5F5',
  brandSubtle: '#EEF2FF',
  secondarySurface: '#FFECF3',
  successSurface: '#EDF7ED',
  warningSurface: '#FFF4E5',
  warningSoft: '#F5DC98',
  infoSurface: '#E5F6FD',
  errorSurface: '#FDEDED',
  errorStrongSurface: '#B13C3C91',
  borderDefault: '#E0E0E0',
  borderInput: 'rgba(0, 0, 0, 0.23)',
  borderSeparator: '#E6E6E6',
  borderHeader: '#F7F0F7',
  borderMedium: '#C9C5CA',
  borderStrong: '#AEAEAE',
  borderContrast: '#000000',
  menuItemActive: 'rgba(89, 84, 168, 0.08)',
  tooltipSurface: '#ECE8F4',
  inputDisabledSurface: 'rgba(0, 0, 0, 0.06)',
  sidebarActiveSurface: '#3B4247',
  sidebarSurface: '#303539',
  scrollbarLightThumb: '#999999',
  deletedTableRowSurface: '#F6F6F6',
  tableRowHoverSurface: '#F1F1F1',
  inputIcon: '#4D4C59',
  softShadow: 'rgba(15, 23, 42, 0.05)',
  softBorder: 'rgba(15, 23, 42, 0.08)',
  shadowMedium: 'rgba(0, 0, 0, 0.15)',
  shadowDefault: 'rgba(0, 0, 0, 0.2)',
  shadowStrong: 'rgba(0, 0, 0, 0.3)',
  shadowContrast: 'rgba(0, 0, 0, 0.5)',
  loadingOverlay: 'rgba(255, 255, 255, 0.4)',
  transparentWhite: 'rgba(255, 255, 255, 0)',
  onBrandMuted: 'rgba(255, 255, 255, 0.8)',
  timelineFeedback: '#219AAE',
  timelineStrategy: '#A82682',
  timelineNote: '#DD7919',
  timelineEmail: '#2F76AE',
  timelineCall: '#735BA0',
  timelineMeeting: '#45A667',
  timelineDemo: '#6DBA7B',
  timelinePlanning: '#8CB8C3',
  timelineSkipped: '#E53A2E',
} as const;

export const foundationMuiColorValues = {
  primary: foundationColors.primary,
  secondary: foundationColors.secondaryAccent,
  success: foundationColors.success,
  error: foundationColors.error,
  warning: foundationColors.warning,
  info: foundationColors.info,
} as const;
